<template>
  <section>
    <el-dialog title="导入商品名录" :visible.sync="visible" width="45%" :close-on-click-modal="false" :before-close="close">
      <div class="item">
        <div class="item_side item_title">导入商品名录</div>
        <div class="item_main">
          <el-upload
            ref="upload"
            action=""
            :on-remove="handleRemove"
            :auto-upload="false"
            :multiple="false"
            :limit="1"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="success" :loading="uploadFileLoading" @click="submitUpload">上传到服务器</el-button>
            <el-button style="margin-left: 10px" size="small" type="primary" :loading="excelDownloading" @click="templateDownload">下载模板</el-button>
          </el-upload>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="close">取消</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { goodsTemplate, importGoods } from '@/api/crossborder/collection/abroadCollection'
import File from '@/utils/file'
export default {
  props: {},
  data: function () {
    return {
      visible: false,

      excelDownloading: false,
      uploadFileLoading: false,
    }
  },

  methods: {
    open() {
      this.visible = true
    },

    close() {
      this.visible = false
      this.uploadFileLoading = false
      this.templateDownloading = false

      this.$refs.upload.clearFiles()
    },

    // 模板下载，这个模板就是还原明细模板
    templateDownload() {
      this.excelDownloading = true
      goodsTemplate({ platformType: '02' })
        .then((res) => {
          this.excelDownloading = false
          File.output(res)
        })
        .catch((err) => {
          this.excelDownloading = false
          console.log('下载出错', err)
        })
    },

    submitUpload() {
      // console.log('this.$refs.upload.uploadFiles', this.$refs.upload.uploadFiles)

      let file = (this.$refs.upload.uploadFiles.length > 0 && this.$refs.upload.uploadFiles[0].raw) || null
      if (!file) {
        this.$message.error('请先选择文件')
        return
      }
      if (file.size > 1024 * 1024 * 20) {
        this.$message.error('上传文件请小于20M')
        return
      }

      const form = new FormData() // FormData 对象
      form.append('file', file) // 文件对象  'file'是后台接收的参数名
      form.append('platformType', '02')
      form.append('operator', this.$store.getters.merName)
      form.append('merNo', this.$store.getters.merNo)
      form.append('merName', this.$store.getters.merName)
      this.$refs.upload.uploadFiles[0].status = 'loading'
      this.uploadFileLoading = true
      importGoods(form)
        .then((res) => {
          this.uploadFileLoading = false
          if (res.data.checkCode === '9999') {
            this.$refs.upload.uploadFiles[0].status = 'fail'
            this.$message.error('上传文件格式错误')
          } else {
            // this.$refs.upload.uploadFiles[0].status = 'success'
            this.$refs.upload.uploadFiles = []
            this.$message.success('上传成功')
            this.$emit('success')
            this.close()
          }
        })
        .catch((error) => {
          this.uploadFileLoading = false
          this.$refs.upload.uploadFiles[0].status = 'fail'
          console.log(error) // 请求失败返回的数据
        })
    },

    handleRemove(file, fileList) {
      // console.log('file fileList', file, fileList)
    },
  },
}
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: row;
  padding: 12px 0px;

  .item_title {
    line-height: 32px;
    text-align: right;
    font-size: 16px;
    color: #909399;
    font-weight: 600;
  }

  .item_main {
    flex: 1;
    padding: 0px 8px;
  }
}
</style>